import Vue from "vue";

export default {
    install: (Vue, options) => {
        // Add components
    }
};